import { render } from "./confirmation.vue?vue&type=template&id=d9d2feb2&scoped=true"
import script from "./confirmation.vue?vue&type=script&lang=ts"
export * from "./confirmation.vue?vue&type=script&lang=ts"

import "./confirmation.vue?vue&type=style&index=0&id=d9d2feb2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d9d2feb2"

export default script